<script>
  /* ホーム画面への追加をすすめるポップアップ。
     出す条件の判定は install.svelte.js 側にある。 */
  import { solvedCount } from "../lib/economy.js";
  import { progress } from "../lib/state.svelte.js";
  import {
    install,
    shouldShowInstall,
    openInstall,
    snoozeInstall,
    neverInstall,
    promptInstall,
  } from "../lib/install.svelte.js";

  let checked = $state(false);

  // 正解数が増えたタイミングで見直す。1セッションで一度出したら
  // 閉じたあとに出し直さない（checked で止める）。
  $effect(() => {
    // solvedCount() は progress.solved のキーを走査するので、
    // 正解が増えたときにこの効果が再実行される
    const n = solvedCount();
    void install.canPrompt;
    if (checked || install.visible) return;
    if (shouldShowInstall(n)) {
      checked = true;
      // 正解演出とぶつからないよう少し待つ
      setTimeout(openInstall, 1200);
    }
  });

  const streakLine = $derived(
    progress.streak > 1
      ? `いま ${progress.streak} 日連続で学習中です。`
      : "1日3問でも、続ければ旅は進みます。"
  );
</script>

{#if install.visible}
  <div
    class="install-pop"
    onclick={snoozeInstall}
    onkeydown={(e) => e.key === "Escape" && snoozeInstall()}
    role="button"
    tabindex="-1"
  >
    <div
      class="install-card"
      onclick={(e) => e.stopPropagation()}
      onkeydown={() => {}}
      role="presentation"
    >
      <div class="install-em">📲</div>
      <h3 class="install-title">ホーム画面に追加しませんか？</h3>
      <p class="install-lead">
        アイコンから1タップで開けるようになります。{streakLine}
      </p>

      {#if install.platform === "ios"}
        <ol class="install-steps">
          <li>
            画面下（iPad は上）の共有ボタン
            <svg class="ios-share" viewBox="0 0 24 24" aria-label="共有">
              <path
                d="M12 3v11M12 3l-3.2 3.2M12 3l3.2 3.2"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 10H5.6A1.6 1.6 0 0 0 4 11.6v7.8A1.6 1.6 0 0 0 5.6 21h12.8a1.6 1.6 0 0 0 1.6-1.6v-7.8A1.6 1.6 0 0 0 18.4 10H17"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            をタップ
          </li>
          <li>メニューから <b>「ホーム画面に追加」</b> を選ぶ</li>
          <li>右上の <b>「追加」</b> をタップ</li>
        </ol>
        <p class="tiny muted">※ Safari で開いているときだけ追加できます。</p>
        <button class="btn submit" style="margin-top:14px" onclick={neverInstall}>
          追加した / 閉じる
        </button>
      {:else if install.canPrompt}
        <button class="btn submit" style="margin-top:14px" onclick={promptInstall}>
          ホーム画面に追加する
        </button>
      {:else}
        <!-- アカウント画面から自分で開いた場合など、
             ブラウザのダイアログをこちらから呼べないとき -->
        <ol class="install-steps">
          <li>ブラウザのメニュー（<b>⋮</b>）を開く</li>
          <li><b>「ホーム画面に追加」</b> または <b>「アプリをインストール」</b> を選ぶ</li>
        </ol>
        <button class="btn submit" style="margin-top:8px" onclick={neverInstall}>
          追加した / 閉じる
        </button>
      {/if}

      <div class="install-foot">
        <button class="btn ghost install-mini" onclick={snoozeInstall}>あとで</button>
        <button class="btn ghost install-mini" onclick={neverInstall}>表示しない</button>
      </div>
    </div>
  </div>
{/if}
